import { NgModule } from '@angular/core';
import { StatusBar } from './status-bar';

@NgModule({
  declarations: [StatusBar],
  exports: [StatusBar],
})
export class StatusBarModule { }
